import { BRAND } from "@/data/site";

interface LeadFormProps {
  /** Kept for API compatibility; the embedded form manages its own fields. */
  defaultService?: string;
  compact?: boolean;
}

export function LeadForm(_props: LeadFormProps) {
  return (
    <div className="space-y-4">
      <iframe
        src="https://vrp-flooring-quote.vibepreview.com"
        width="100%"
        height={1000}
        style={{ border: 0, maxWidth: "672px", margin: "0 auto", display: "block" }}
        title="Free Estimate Form"
        loading="lazy"
      />
      <p className="text-xs text-muted-foreground">
        Prefer to talk? Call{" "}
        <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="font-medium text-accentInk hover:underline">
          {BRAND.phoneDisplay}
        </a>{" "}
        — we answer 24/7.
      </p>
    </div>
  );
}
